<app-logged class="architect-closing-form">
  <header class="architect-closing-form__header">
    <h2>NOVO FECHAMENTO DE ARQUITETOS</h2>
    
    <div class="architect-closing-form__header__actions">
      <button class="btn-primary-light" mat-button (click)="goBack()">VOLTAR</button>
    </div>
  </header>

  <form [formGroup]="formGroup" (ngSubmit)="submit()">
    <mat-card>
      <div class="row">
        <div class="col-12 col-sm-6">
          
          <mat-card-content>
            <mat-form-field>
              <mat-label>Data inicial</mat-label>
              <input matInput type="date" formControlName="startDate" />
              <mat-error *ngIf="formGroup.controls.startDate?.invalid">
                {{ errorsService.messageErrorFor(formGroup.controls.startDate) }}
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Data final</mat-label>
              <input matInput type="date" formControlName="endDate" />
              <mat-error *ngIf="formGroup.controls.endDate?.invalid">
                {{ errorsService.messageErrorFor(formGroup.controls.endDate) }}
              </mat-error>
            </mat-form-field>
          </mat-card-content>
        </div>
      </div>
      <div class="architect-closing-form__actions">
        <button class="btn-primary-light" type="submit" mat-button>Salvar</button>
      </div>
    </mat-card>
  </form>

  </app-logged>